import {
  MembershipFieldSet,
  PaymentFormFields,
  PersonalInformationFormFields,
} from "~/types/account/account.types";

export const personalInformationFieldsetsFr: MembershipFieldSet<
  keyof PersonalInformationFormFields
>[] = [
  {
    legend: "Adresse",
    inputs: [
      {
        register: "phoneNumber",
        placeholder: "Numéro de téléphone",
        size: 14,
        disabled: true,
      },
      {
        register: "address1",
        placeholder: "Adresse Ligne 1",
        disabled: true,
      },
      {
        register: "address2",
        placeholder: "Adresse Ligne 2",
        disabled: true,
      },
      {
        register: "city",
        placeholder: "Ville",
        disabled: true,
        size: 9,
      },
      {
        register: "postalCode",
        placeholder: "postal code",
        disabled: true,
        size: 7,
      },
    ],
  },
  {
    legend: "Occupation",
    inputs: [
      {
        register: "industry",
        placeholder: "Secteur",
        disabled: true,
        size: 9,
      },
      {
        register: "jobTitle",
        placeholder: "Intitulé du poste",
        disabled: true,
        size: 7,
      },
      {
        register: "companyName",
        placeholder: "Nom de l'entreprise",
        disabled: true,
      },
      {
        register: "professionalEmail",
        placeholder: "Email professionnel (Si différent de l'email personnel)",
        disabled: true,
        size: 23,
      },
      {
        register: "town",
        placeholder: "Ville",
        disabled: true,
        size: 9,
      },
    ],
  },
];

export const personalInformationFieldsets: MembershipFieldSet<
  keyof PersonalInformationFormFields
>[] = [
  {
    legend: "Address",
    inputs: [
      {
        register: "phoneNumber",
        placeholder: "phone number",
        size: 14,
        disabled: true,
      },
      {
        register: "address1",
        placeholder: "Adresse Line One",
        disabled: true,
      },
      {
        register: "address2",
        placeholder: "Adresse Line Two",
        disabled: true,
      },
      {
        register: "city",
        placeholder: "city",
        disabled: true,
        size: 9,
      },
      {
        register: "postalCode",
        placeholder: "postal code",
        disabled: true,
        size: 7,
      },
    ],
  },
  {
    legend: "Job",
    inputs: [
      {
        register: "industry",
        placeholder: "industry",
        disabled: true,
        size: 9,
      },
      {
        register: "jobTitle",
        placeholder: "job title",
        disabled: true,
        size: 7,
      },
      {
        register: "companyName",
        placeholder: "company name",
        disabled: true,
      },
      {
        register: "professionalEmail",
        placeholder: "professional email (if different)",
        disabled: true,
        size: 23,
      },
      {
        register: "town",
        placeholder: "town",
        disabled: true,
        size: 9,
      },
    ],
  },
];

export const paymentFieldsets: MembershipFieldSet<keyof PaymentFormFields>[] = [
  {
    legend: "Moyen de paiement",
    inputs: [
      {
        register: "cardNumber",
        placeholder: "0000 0000 0000 0000",
        label: "Moyen de paiment",
        size: 17,
        disabled: true,
      },
    ],
  },
];

export const paymentFieldsetsEn: MembershipFieldSet<keyof PaymentFormFields>[] =
  [
    {
      legend: "Card Number",
      inputs: [
        {
          register: "cardNumber",
          placeholder: "0000 0000 0000 0000",
          label: "Card Number",
          size: 17,
          disabled: true,
        },
      ],
    },
  ];
